import { CancelOrderPurpose, CancelOrderRequestMessage, CancelOrderRequestMessageType } from "../interface/interface";

export const cancelOrderRequestMessage: CancelOrderRequestMessageType = (
  status
) => {
  if (status == CancelOrderPurpose.Approved) {
    return (
      CancelOrderRequestMessage.CANCEL_APPROVED_MESSAGE
    );
  } else {
    return (
      CancelOrderRequestMessage.CANCEL_REJECTED_MESSAGE
    );
  }
};
